export const grupos = [
    'BUNGE',
    'BUNGE_ALVORADA',
    'COFCO',
    'VITERRA',
    'ALVORADA'
];
